import angular from 'angular';
import constants from 'app/constants';
import {
  ecatDataService,
  ecatSharedModelService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';

import criStatement from './criStatement';
import controller from './cri-sub-category.controller';
import directive from './cri-sub-category.directive';


export default angular.module('app.components.advisory.ecat.criSubCategory', [
  alerts,
  ecatDataService,
  ecatSharedModelService,
  confirmDialog,
  constants,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
  criStatement,
])
  .directive('ecatSubCategory', directive)
  .controller('CRISubCategoryController', controller)
  .name;

console.log('app.components.advisory.ecat.criSubCategory created');
